<my-products-layout *ngIf="assets"
    [assets]="assets"
></my-products-layout>